import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { Button, Col, Form, Image, Modal, Table } from "react-bootstrap";
import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  getUserTickets,
  admin_get_user_tickets_filter,
  updateTicketStatus,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";

import { AmealioLoader } from "../../../Loader/AmealioLoader";
import SelectFilter from "../../../reusableComponents/selectFilter";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import AddUserOpenIssues from "./InsideAllPageComponent/AddUserOpenIssues";
import EditUserOpenIssues from "./InsideAllPageComponent/EditUserOpenIssues";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { OpenIssuesUserTableBody } from "./OpenIssuesUserTableBody";
import isEmpty from "../../../../store/validation/is-Empty";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import NoContent from "../../../reusableComponents/NoContentComponent";
const SuperAdminOpenIssuesUsers = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    restaurantReverse: "",
    restaurant_type: "",
    displayFilter: false,
  });
  const [dateQuery, setDateQuery] = useState("");

  const pageChangeButtonHandler = (value) => {
    setSelectedTab(value);
  };

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Called User";
    } else if (status === 9) {
      return "Completed";
    }
  };

  const onSuccessChangeTicketStatus = () => {
    props.getUserTickets(
      selectedTab,
      dateQuery.startDate !== undefined
        ? moment().format(dateQuery.startDate)
        : moment().format("YYYY-MM-DD"),
      dateQuery.endDate !== undefined
        ? moment().format(dateQuery.endDate)
        : moment().format("YYYY-MM-DD"),
      onSuccessGetAllTickets
    );
    onCloseModal();
  };
  const onErrorChangeTicketStatus = () => {
    onCloseModal();
  };

  const onSubmitHandler = (e) => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.status = currentStatus;
    props.updateTicketStatus(
      token,
      formData,
      ticketId,
      onSuccessChangeTicketStatus,
      onErrorChangeTicketStatus
    );
  };

  const onSuccessGetAllTickets = () => {
    setLoading(false);
  };
  const updateLatest = () => {
    props.getUserTickets(
      selectedTab,
      dateQuery.startDate !== undefined
        ? moment().format(dateQuery.startDate)
        : moment().format("YYYY-MM-DD"),
      dateQuery.endDate !== undefined
        ? moment().format(dateQuery.endDate)
        : moment().format("YYYY-MM-DD"),
      onSuccessGetAllTickets
    );
  };

  useEffect(() => {
    setLoading(true);
    props.getUserTickets(
      selectedTab,
      dateQuery.startDate !== undefined
        ? moment().format(dateQuery.startDate)
        : moment().format("YYYY-MM-DD"),
      dateQuery.endDate !== undefined
        ? moment().format(dateQuery.endDate)
        : moment().format("YYYY-MM-DD"),
      onSuccessGetAllTickets
    );
  }, [selectedTab]);

  const [modalStatus, setModalStatus] = useState(false);
  const onCloseModal = () => {
    setModalStatus(false);
  };

  const [currentStatus, setCurrentStatus] = useState(0);
  const statusTypes = [
    { name: "New", status: 0 },
    { name: "In-Progress", status: 1 },
    { name: "Awaiting Feedback", status: 2 },
    { name: "On Hold", status: 3 },
    { name: "Re-Opened", status: 4 },
    { name: "Resolved", status: 5 },
    { name: "Closed", status: 6 },
    { name: "Archive", status: 7 },
    { name: "Called User", status: 8 },
    { name: "Completed", status: 9 },
  ];
  const [ticketId, setTicketId] = useState();

  const onShowModal = (status, ticketId) => {
    setCurrentStatus(status);
    setTicketId(ticketId);
    setModalStatus(true);
  };

  const onChangeTempStatus = (status) => {
    setCurrentStatus(status);
  };

  useEffect(() => {
    dispatch(
      admin_get_user_tickets_filter(
        props.auth.user.accessToken,
        selectedTab,
        dateQuery.startDate !== undefined
          ? dateQuery.startDate
          : moment().format("YYYY-MM-DD"),
        dateQuery.endDate !== undefined
          ? dateQuery.endDate
          : moment().format("YYYY-MM-DD")
      )
    );
  }, [dateQuery]);

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (value) => (e) => {
    setState({
      ...state,
      restaurantReverse: value,
      restaurant_type: "",
    });
    handleClose();
  };

  const onClickShowFilter = () => {
    setState({
      ...state,
      displayFilter: !state.displayFilter,
    });
  };

  const handleShowFilter = () => {
    setState({
      ...state,
      displayFilter: false,
    });
  };
  const handleSaveButton = () => {
    console.log("hi");
  };
  const issuesData = props.allUserIssues;
  let filtereddata = [];
  const RenderTableBody = () => {
    if (state.restaurantReverse === "A-Z") {
      filtereddata = issuesData.sort((a, b) => {
        if (
          a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name
        )
          return -1;
        if (
          a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name
        )
          return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filtereddata = issuesData.sort((a, b) => {
        if (
          a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name
        )
          return 1;
        if (
          a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name
        )
          return -1;
        return 0;
      });
    }
    filtereddata = issuesData.filter((item) => {
      return (
        item?._id.includes(search) ||
        item?.restaurant_id?.restaurant_name
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item?.description.toLowerCase().includes(search.toLowerCase()) ||
        item?.ticket_number.toLowerCase().includes(search.toLowerCase()) ||
        item?.user_id?.first_name.toLowerCase().includes(search.toLowerCase())
      );
    });
    if (!isEmpty(filtereddata)) {
      return filtereddata.map((data, index) => (
        <React.Fragment key={index}>
          <OpenIssuesUserTableBody issue={data} onShowModal={onShowModal} />
        </React.Fragment>
      ));
    } else {
      return <NoContent />
    }
  };



  const downloadData = {
    headers: [
      { label: "Ticket No \n Request No", key: "ticketNo" },
      { label: "Restaurant Name \n & ID", key: "ResName" },
      { label: "User Name", key: "username" },
      { label: "Issue Type", key: "issueType" },
      { label: "Issue Category", key: "categorty" },
      { label: "Issue Description", key: "description" },
      { label: "Status", key: "status" },
      { label: "Ticket Date", key: "date" },
      { label: "Time", key: "time" },
    ],
    data: issuesData?.map((ele) => {
      return {
        ticketNo: `${ele?.ticket_number || "-"} \n ${ele?.seating_request_no || ""}`,
        ResName: `${ele?.restaurant_id?.restaurant_name || ""} \n ${ele?.restaurant_id?._id || ""}`,
        username: `${ele?.user_id?.first_name || ""}`,
        issueType: ele?.ticket_category_id?.category_name || "",
        categorty: ele?.ticket_sub_category_id?.title,
        description: ele?.description,
        status: calcStatus(ele?.status),
        date: `${moment(ele?.createdAt).format("Do MMM, YYYY")}`,
        time: `${moment(ele?.createdAt).format("hh : mm A")}`,
      };
    }),
  };

  return (
    <React.Fragment>
      {!loading ? <></> : <AmealioLoader />}
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Col>
              <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Open Tickets - Users
                </div>
                {/* {moment("2021-06-05T01:55:42.226+00:00").format(
                  "DD/MM/YYYY hh:mm A"
                )} */}
                <AddUserOpenIssues updateLatest={updateLatest} />
              </Col>
            </Col>
            <div className="super-admin-inside-right-side-panel">
              <div className="row align-items-center justify-content-between">
                <div className="col-6">
                  <div className="row">
                    <div className="col-9">
                      <Form.Control
                        type="text"
                        placeholder="Search by restaurant/user name, request type, ticket number"
                        className="amSearch"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-5">
                      <div className="mr-3">
                        <SelectFilter
                          onDateChange={(data, type) =>
                            onDateChangeHandler(data, type)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <SortComponent
                          handleClick={handleClick}
                          anchorEl={anchorEl}
                          handleClose={handleClose}
                          selectClick={(data) => handleSelect(data)}
                        // selectClick={(data) => props.handleSelectOne(data)}
                        />
                        <div
                          className="f10-400"
                          align="center"
                          onClick={() => onClickShowFilter()}
                        >
                          <img
                            src={require("../../../../assets/images/iconButton/filtericon.png")}
                            width="35px"
                          />
                          <br />
                          Filter
                        </div>
                        <CSVDownloader
                          filename={"Open Tickets - Users"}
                          headers={downloadData.headers}
                          data={downloadData.data}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex align-items-center">
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 0 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(0)}
                  >
                    New
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 1 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(1)}
                  >
                    In-Process
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 6 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(6)}
                  >
                    Closed
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 4 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(4)}
                  >
                    All
                  </Button>
                </div>
              </div>
              {state.displayFilter && (
                <div className="row">
                  <div className="col-12">
                    <div className="enWhiteBox mt-3">
                      <Form className="row justify-content-between">
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                Restaurant type
                              </InputLabel>
                              <Select
                                // value={props.resType}
                                // onChange={props.resTypeChangeHandler}
                                label="Restaurant type"
                                inputProps={{
                                  name: "Restaurant_type",
                                  id: "outlined-Restaurant-type",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {/* {props.categoryList.map((data, index) => {
                          return (
                            <option value={data} key={index}>
                              {data}
                            </option>
                          );
                        })} */}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <TextField
                                variant="outlined"
                                label="Location"
                                fullWidth
                              // value={props.location}
                              // onChange={props.onChangeLocation}
                              />
                            </FormControl>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="outline-secondary"
                              className="btn-lg mr-4 px-5"
                              onClick={() => handleShowFilter()}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="danger"
                              className="btn-lg px-5"
                              onClick={() => handleSaveButton()}
                            >
                              Search
                            </Button>
                          </div>
                        </Col>
                      </Form>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
              <Table className="enOpenTicketsUsers HideShowTable">
                <thead>
                  <tr
                    className="super_admin_all_users_table_head"
                    style={{ width: "95%", margin: "auto" }}
                  >
                    <th className="f12-700 text-break" style={{ width: "10%" }}>
                      Ticket No/ <br />
                      Request No
                    </th>
                    <th className="f12-700" style={{ width: "18%" }}>
                      Restaurant Name <br /> & ID
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      User Name
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Issue Type
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Issue Category
                    </th>
                    <th className="f12-700" style={{ width: "18%" }}>
                      Issue Description
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      {" "}
                      Status
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Ticket Date/ <br />
                      Time{" "}
                    </th>
                    <th className="f12-700" style={{ width: "14%" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                {props.auth.loader || props.auth.secondary_loader ? (
                  <SmallLoader />
                ) : (
                  RenderTableBody()
                )}
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalStatus}
        backdrop="static"
        keyboard={false}
        centered
        className="enStatusListModal"
        size="sm"
        onHide={(e) => onCloseModal()}
      >
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Suggestion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="pb-4 f16-500">
            Select one relevant option from below
          </div>
          <ul type="none" className="enStatusList">
            {statusTypes.map((status, index) => (
              <li
                onClick={() => onChangeTempStatus(status.status)}
                key={index}
                className={`${currentStatus === status.status ? "active" : ""}`}
              >
                {status.name}
              </li>
            ))}
          </ul>
          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => onSubmitHandler()}
              className={`btn-lg px-5 btn150px `}
            >
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminOpenIssuesUsers.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserTickets: PropTypes.func.isRequired,
  admin_get_user_tickets_filter: PropTypes.func.isRequired,
  updateTicketStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allUserIssues: state.userManagement.allUserIssues,
});

export default connect(mapStateToProps, {
  getUserTickets,
  admin_get_user_tickets_filter,
  updateTicketStatus,
})(SuperAdminOpenIssuesUsers);
